/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDisplay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 13v6h-9v-6zm-11 0v6H2v-6zm9 2h-5v2h5zM9 15H4v2h5zM22 5v6h-9V5zM11 5v6H2V5zm9 2h-5v2h5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDisplay as Display };
